import type { ProductCostView } from '@wms/domain';
import { useState } from 'react';
import { api } from '../../api';
import { fmt } from '../../format';
import { ErrorBanner, Spinner, useLoad } from '../../ui';
import { CostField } from '../seller/CostField';

/**
 * "Maliyet (birim, KDV hariç)" on the seller's own product page: what Kârlılık takes off per unit sold. Its own
 * save (the cost API), never part of the product's form: warehouse admins edit products in the seller's name
 * and must neither see nor overwrite it, so the page shows it to the seller alone.
 */
export function ProductCostCard({ productId, canEdit }: { productId: string; canEdit: boolean }) {
  const loaded = useLoad(() => api<ProductCostView[]>('GET', `/api/profit/costs?productId=${productId}`), [productId]);
  const [saved, setSaved] = useState<ProductCostView | null>(null);
  const cost = saved ?? loaded.data?.[0] ?? null;
  return (
    <section className="card">
      <div className="card-h">
        <h2>Maliyet (birim, KDV hariç)</h2>
        <span className="sub">Kârlılık sayfasında net kârdan düşülür; yalnız siz görürsünüz, depo görmez</span>
      </div>
      <div className="card-b">
        {loaded.error && <ErrorBanner message={loaded.error} onRetry={() => void loaded.reload()} />}
        {!cost ? (
          !loaded.error && <Spinner />
        ) : (
          <div className="form-grid">
            <div className="field">
              <label htmlFor="p-cost">Birim maliyet (₺, KDV hariç)</label>
              <CostField id="p-cost" cost={cost} canEdit={canEdit} onSaved={setSaved} />
              <span className="hint">
                {cost.changedAt ? `Son değişiklik ${fmt.stamp(cost.changedAt)}. ` : ''}Enter’a basınca ya da kutudan çıkınca kaydedilir; boş bırakmak siler. İlk
                maliyet önceki siparişlere de uygulanır, sonraki değişiklikler geçmişi değiştirmez.
              </span>
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
